<template>
    <v-expansion-panel
        class="outing white--text"
        active-class="active"
    >
        <v-expansion-panel-header hide-actions>
            <v-row
                class="ma-0"
                :class="(index === 1 ? 'pb-7' : 'py-7')"
            >
                <v-col cols="1" class="pa-0">
                    <v-avatar color="primary" size="40">
                        <span class="font-weight-bold">{{ index }}</span>
                    </v-avatar>
                </v-col>
                <v-col cols="10" class="pa-0 pl-3">
                    <h3 class="outing-title">{{ outing.title }}</h3>
                </v-col>
                <v-col cols="1" class="pa-0 d-flex justify-center">
                    <v-icon class="outing-toggle">
                        mdi-chevron-down
                    </v-icon>
                </v-col>
            </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-row class="ma-0 pb-6">
                <v-spacer></v-spacer>
                <v-col cols="10" class="text-left pa-0 pl-3">
                    <p class="outing-content mb-4">{{ outing.content }}</p>

                    <p class="outing-link">
                        <a
                            :href="outing.url"
                            target="_blank"
                        >
                            Learn More
                        </a>
                    </p>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
export default {
    name: "OutingPanel",

    props: {
        outing: {
            type: Object,
            required: true,
        },

        index: {
            type: Number,
            default: 1,
        },
    },
}
</script>

<style scoped>
/** Outing Block styles */
div.section-dark .outing {
    background-color: #373e55;
}

div.outing {
    border-bottom: 1px solid #fff;
}

div.outing .v-expansion-panel-header {
    padding: 0;
}

div.outing>>>.v-expansion-panel-content__wrap {
    padding: 0;
}

div.outing .v-avatar {
    font-size: 20px;
    line-height: 20px;
}

div.outing .outing-title {
    font-size: 28px;
    line-height: 40px;
}

div.outing .outing-toggle {
    background-color: rgba(255, 255, 255, 0.2);
    color: #fff !important;
    font-size: 28px;
    border-radius: 30px;
    padding: 2px;
    margin: auto;
}

div.outing.active .outing-toggle {
    transform: rotate(-180deg);
}

@media (max-width: 450px) {
    .v-application .pl-3 {
        padding-left: 24px !important;
    }
}

div.outing .outing-link a {
    font-weight: bold;
    color: #fff !important;
    text-decoration: underline !important;
}
</style>
